export const eulaDisabledPartners = ["pcc", "pcc_wound"];
